import ApiService from '@/plugins/apiService'

export default {
  state: {
    support: []
  },

  mutations: {
    SET_NOTIFICATIONS(state, { module, notifications }) {
      state[module] = notifications
    }
  },

  actions: {
    async fetchNotifications({ commit }) {
      const { data: supportNots } = await ApiService.getUnreadedSupportAnswers()
      commit('SET_NOTIFICATIONS', { module: 'support', notifications: supportNots })
    },

    async removeNotifications({ commit, state }, { removingMethod, module, ids }) {
      ids.forEach(async idToRemove => {
        if (state[module].includes(idToRemove)) {
          const response = await ApiService[removingMethod]({ id: idToRemove }) // TODO
          console.log(response)
          const notifications = state[module].filter(id => id !== idToRemove)
          commit('SET_NOTIFICATIONS', { module, notifications })
        }
      })
    }
  }
}
